import styled from 'styled-components';
import { rgba } from 'polished';

import OpenExternallyIcon from '#/assets/OpenExternallyIcon';

import BaseExternalLink from '#/components/shared/ExternalLink';
import StatusBadge from '#/components/common/StatusBadge';

import { useTranslation } from '#/features/localization/utils';

import { cFFFFFF, mainGridGapColor } from '#/colors';

import { STATS_URL } from '#/routes-external';

export default function Footer() {
  const { t } = useTranslation();
  return (
    <Container>
      <StatusBadge />
      <ExternalLink href={STATS_URL}>
        {t('Stats')} <OpenExternallyIcon size={8} />
      </ExternalLink>
    </Container>
  );
}

const Container = styled.div`
  border-top: 1px solid ${mainGridGapColor};
  height: 24px;
  min-height: 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
  font-size: 11px;

  a {
    color: ${rgba(cFFFFFF, 0.5)};
    font-size: 11px;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 11px;

    &:hover {
      color: ${rgba(cFFFFFF, 0.7)};
    }
  }
`;

const ExternalLink = styled(BaseExternalLink)`
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 2px 0;
`;
